import React from 'react';
import classnames from 'classnames';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import classes from '../../select-pantones-popup.scss';
const Footer = ({
  confirmText,
  cancelText,
  hasColors,
  onContinue,
  onCancel
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.buttonContainer, cancelText && classes.buttonContainerFlex)
}, cancelText && /*#__PURE__*/React.createElement(Button, {
  dataButton: "Cancel",
  className: classes.buttonSkip,
  type: "primary",
  size: "normal",
  onClick: onCancel,
  textTransform: ButtonTextTransform.none
}, cancelText), /*#__PURE__*/React.createElement(Button, {
  dataButton: "ConfirmColors",
  className: classes.buttonContinue,
  type: "primary",
  size: "normal",
  onClick: onContinue,
  disabled: !hasColors,
  textTransform: ButtonTextTransform.none
}, confirmText));
export default Footer;